import { render, staticRenderFns } from "./eq_notice.vue?vue&type=template&id=1cb81a72"
import script from "./eq_notice.vue?vue&type=script&lang=js"
export * from "./eq_notice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports